<template>
  <div id="app" style="background: #2b2e7a;">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>    
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true //解决重新加载时刷新问题
    };
  },  
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue